import * as React from "react";
import { orderBy } from "lodash";
import { WebPortalClient, Alert, DiarySession, Visit } from "webportalclient";
import AlertComponent, { AlertCategoryEnum } from "../../misc/components/Alert";
import { DateTimeAccuracy, LocalizedDateTime } from "../../misc/components/LocalizedDateTime";

interface DiaryAlertViewProps {
    alerts: Alert[];
    session: DiarySession;
}

export interface DiaryAlertsViewProps {
    sessions: DiarySession[];
    alerts: Alert[];
   
}

export const DiaryAlertView = ({ alerts, session }: DiaryAlertViewProps) => {
    const alertView = (alerts: Alert[]) => {      
        return (
            <table className="table table-striped table-hover" data-automationid="AlertTable">
                <thead>
                    <tr>
                        <th>Occurred</th>
                        <th>Alert</th>
                        <th>Details</th>
                    </tr>
                </thead>
                <tbody>
                    {alerts.map(a => (
                        <tr key={a.id}>
                            <td><LocalizedDateTime time={a.occurred} accuracy={DateTimeAccuracy.Second} isTooltip={true} /></td>
                            <td>{a.headline}</td>
                            <td>{a.content}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }
        
    return (
        <>
            <div key={`Alert${alerts[0].id}`} data-automationid="DiaryAlertItem">
                <h4 className="text-primary">
                    Session {session.name} performed on <LocalizedDateTime time={session.occurred} accuracy={DateTimeAccuracy.Second} isTooltip={true} />
                </h4>
                {alertView(alerts)}
            </div>          
        </>
    );
}

export const DiaryAlertsView = ({ sessions, alerts }: DiaryAlertsViewProps) => {
    if (alerts.length === 0) {
        return (<AlertComponent show={true} category={AlertCategoryEnum.Info} automationid="NoAlertsInfo">
            There are no alerts recorded for this date
        </AlertComponent>);
    }

    const groupedAlertsBySession: Alert[][] = Object.values(alerts.reduce((r, v, i, a, k = v.triggeredBySessionId) => ((r[k] || (r[k] = [])).push(v), r), {}));

    return (
        <>
            {groupedAlertsBySession.map(a => (<DiaryAlertView key={`DiaryAlertView${a[0].triggeredBySessionId}`} alerts={a} session={sessions.find(s => s.id === a[0].triggeredBySessionId)} />))}
        </>
    );
}
